import React, { memo } from 'react';

import classNames from 'classnames';
import ReactTooltip, { Place, Type } from 'react-tooltip';

import cls from './CustomReactTooltip.module.css';

interface CustomReactTooltipProps {
    classes?: string;
    tooltipId: string;
    content: string;
    type?: Type;
    place?: Place;
}

export const CustomReactTooltip = memo(
    ({ classes, tooltipId, content, type = 'light', place = 'top' }: CustomReactTooltipProps) => (
        <ReactTooltip
            id={tooltipId}
            aria-haspopup="true"
            effect="solid"
            delayHide={200}
            delayShow={200}
            type={type}
            className={classNames(cls.tooltip, [classes])}
            place={place}
        >
            <p>{content}</p>
        </ReactTooltip>
    )
);
